<template>
  <div style="border: 1px solid #333; padding: 1rem; margin-bottom: 1rem; margin: 1rem -1rem;">
    <p>
      <strong>B.</strong>
      {{ $t("contract.working_hours.option_b.paragraphs.first") }}
    </p>

    <div>{{ $t("contract.working_hours.option_b.label") }}</div>

    <div v-if="guideInAppendix">
      <p>
        <i>{{ $t("contract.working_hours.options.hours_in_appendix") }}</i>
      </p>
    </div>
    <div v-else>
      <p>
        <small>{{ $t("contract.working_hours.option_b.help") }}</small>
      </p>

      <table>
        <tbody>
          <tr>
            <td>
              <span>{{ $t("contract.working_hours.days.monday") }}</span>
            </td>
            <td>
              <span class="user-output">{{ days.monday }}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span>{{ $t("contract.working_hours.days.tuesday") }}</span>
            </td>
            <td>
              <span class="user-output">{{ days.tuesday }}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span>{{ $t("contract.working_hours.days.wednesday") }}</span>
            </td>
            <td>
              <span class="user-output">{{ days.wednesday }}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span>{{ $t("contract.working_hours.days.thursday") }}</span>
            </td>
            <td>
              <span class="user-output">{{ days.thursday }}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span>{{ $t("contract.working_hours.days.friday") }}</span>
            </td>
            <td>
              <span class="user-output">{{ days.friday }}</span>
            </td>
          </tr>
          <tr>
            <td>
              <span>{{ $t("contract.working_hours.days.saturday") }}</span>
            </td>
            <td>
              <span class="user-output">{{ days.saturday }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<style scoped>
table {
  width: 40%;
  table-layout: fixed;
  margin-block: 1rem;
}

table tr {
  width: 50%;
  margin-bottom: 10px !important;
}

table td {
  padding: 0px;
}
</style>

<script>
export default {
  computed: {
    options() {
      return this.$store.state.contract.workingHours.options;
    },
    guideInAppendix() {
      return this.options.B_guideInAppendix;
    },
    days() {
      return this.$store.state.contract.workingHours.B.days;
    },
  },
};
</script>
